import resolveFactor from './FactorResolver';
import resolveResponsiveValue from './ResponsiveValueResolver';
/**
 * resolves a responsive size value to the plain value
 */
export function resolveResponsiveFactorSize(theme, screenWidth, sizesDefinition, responsiveFactorSize) {
    var responsiveFactor;
    if (isDefinition(responsiveFactorSize)) {
        responsiveFactor = sizesDefinition[responsiveFactorSize];
    }
    else if (responsiveFactorSize === true) {
        responsiveFactor = sizesDefinition.default;
    }
    else {
        responsiveFactor = responsiveFactorSize;
    }
    return resolveResponsiveFactor(theme, screenWidth, responsiveFactor);
}
export function resolveResponsiveFactor(theme, screenWidth, factor) {
    // resolve the active responsive value
    var activeFactor = resolveResponsiveValue(theme, screenWidth, factor);
    // resolve factor to plain value
    return resolveFactor(theme, activeFactor);
}
function isDefinition(value) {
    return typeof value === 'string';
}
//# sourceMappingURL=ComposedResolvers.js.map